import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ComboService,
  ExcelService,
} from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
declare var google;

@Component({
  selector: "purchase-plan-report",
  templateUrl: "purchasePlanReport.html",
})
export class purchasePlanReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  finyearList = [];
  isLoadMask: Promise<any>;
  loadingIndicator: boolean = true;
  seasonList = [];
  currentSlide: number = 0;
  IsWait: boolean = false;

  seasonCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  seasonfinList = [];
  planDetails = [];
  varietyList = [];
  styleList = [];
  style: string;

  planData = {
    fin_id: "",
    season_id: 0,
    season: "",
    total_qty: 0,
    fin_year: "",
  };
  exceldata: any;
  plan_excel_data: any;
  columns: any;
  excelTitle: string;

  constructor(
    public store: Store<fromRootStore.State>,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    public comboservice: ComboService,
    private spin: MatProgressSpinnerModule,
    private excelService: ExcelService,
    private poservice: PurchaseOrderService
  ) {}

  ngOnInit(): void {
    this.finyearCombo();
    this.getPurchasePlanData();
    this.getColumns();
  }

  getColumns() {
    this.columns = [
      {
        cellClass: "txtRight",
        name: "SNO",
        prop: "sno",
        width: "60",
      },
      {
        cellClass: "txtRight",
        name: "Variety",
        prop: "variety",
        width: "60",
      },
      {
        cellClass: "txtRight",
        name: "Tot.Pcs",
        prop: "variety_qty",
        width: "60",
      },
      {
        cellClass: "txtRight",
        name: "Tot.Mtrs",
        prop: "variety_mtrs",
        width: "60",
      },
      {
        cellClass: "txtRight",
        name: "Apprx.Clrs",
        prop: "variety_clrs",
        width: "60",
      },
      {
        cellClass: "txtRight",
        name: "36-100 lump (clrs)",
        prop: "lump_one_width_one_total_clrs",
        width: "60",
      },
      {
        cellClass: "txtRight",
        name: "36-200 lump (clrs)",
        prop: "lump_two_width_one_total_clrs",
        width: "60",
      },
      {
        cellClass: "txtRight",
        name: "44-100 lump (clrs)",
        prop: "lump_one_width_two_total_clrs",
        width: "60",
      },
      {
        cellClass: "txtRight",
        name: "44-200 lump (clrs)",
        prop: "lump_two_width_two_total_clrs",
        width: "60",
      },
      {
        cellClass: "txtRight",
        name: "58-100 lump (clrs)",
        prop: "lump_one_width_three_total_clrs",
        width: "60",
      },
      {
        cellClass: "txtRight",
        name: "58-200 lump (clrs)",
        prop: "lump_two_width_three_total_clrs",
        width: "60",
      },
      {
        cellClass: "txtRight",
        name: "Apprx.Des",
        prop: "variety_designs",
        width: "60",
      },
    ];
  }

  ngAfterViewInit(): void {
    $("#finyear").focus();
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear();

      let checkDate = yyyy + "-" + mm + "-" + dd;
      let curYear = res.data.filter(
        (el) => checkDate >= el.start_date && checkDate <= el.end_date
      );
      if (curYear.length > 0) {
        this.finyearCtrl.setValue(curYear[0].fin_id);
        this.planData.fin_year = curYear[0].finyear;
        this.planData.fin_id = curYear[0].fin_id;
      } else {
        this.finyearCtrl.setValue(res.data[res.data["length"] - 1].fin_id);
        this.planData.fin_year = res[res["length"] - 1].finyear;
        this.planData.fin_id = res[res["length"] - 1].fin_id;
      }
      that.getSeasonList();
    });
  }

  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getBrandNewSeason(params).then((res: any) => {
      this.seasonList = res;
    });
  }

  onSelectFinyear(id) {
    this.planData.season_id = 0;
    var fin_id = id;
    // let seasonfinList = _.filter(this.seasonList, fin_id );
    let seasonfinList = this.seasonList.filter((res) => res.fin_id == fin_id);
    this.seasonfinList = seasonfinList;
    this.seasonCtrl.setValue(
      this.seasonfinList[this.seasonfinList["length"] - 1].season_id
    );
    this.planData.season_id = this.seasonfinList[
      this.seasonfinList["length"] - 1
    ].season_id;
    this.planData.season = this.seasonfinList[
      this.seasonfinList["length"] - 1
    ].season;
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }
    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    list = that.seasonList;

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.planData.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }

  getPurchasePlanData() {
    this.IsWait = true;
    let params = {
      season_id: this.planData.season_id,
      fin_id: this.planData.fin_id,
    };
    this.poservice.getPurchasePlanReportData(params).then((res: any) => {
      this.IsWait = false;
      if (res.success) {
        let planData = JSON.parse(res.planData[0].plan_data);
        this.varietyList = planData.varietyList;
        this.styleList = planData.styleList;
        this.planData.total_qty = res.planData[0].total_qty;

        this.calcTotal();
      } else {
        this.toasterService.pop({
          bodyOutputType: 1,
          type: 'warning',
          title: "Oops...",
          body: "No data found",
        });
        this.varietyList = [];
        this.styleList = [];
        this.planData.total_qty = 0;
      }
    });
  }

  calcTotal() {
    this.styleList.forEach((element) => {
      element["total_qty"] = 0;
      element["total_mtrs"] = 0;
      element["total_designs"] = 0;
      element["total_clrs"] = 0;
      element["lump_one_width_one_total_clrs"] = 0;
      element["lump_two_width_one_total_clrs"] = 0;
      element["lump_one_width_two_total_clrs"] = 0;
      element["lump_two_width_two_total_clrs"] = 0;
      element["lump_one_width_three_total_clrs"] = 0;
      element["lump_two_width_three_total_clrs"] = 0;
      element["style_total_designs"] = 0;

      this.varietyList.forEach((el) => {
        if (el.style == element.style) {
          element["total_qty"] += Number(el.qty);
          element["total_mtrs"] += Number(el.width_total_mtrs);
          element["total_designs"] += Number(el.lump_appr_total_designs);
          element["total_clrs"] += Number(el.lump_appr_tot_clrs);
          element["style_total_designs"] += Number(el.lump_appr_total_designs);

          el.width.forEach((widthEl) => {
            widthEl.lumpData.forEach((lumpEl) => {
              if (lumpEl.lump == 100) {
                if (widthEl.width == 36) {
                  element["lump_one_width_one_total_clrs"] += Number(
                    lumpEl.no_of_clrs
                  );
                }

                if (widthEl.width == 44) {
                  element["lump_one_width_two_total_clrs"] += Number(
                    lumpEl.no_of_clrs
                  );
                }

                if (widthEl.width == 58) {
                  element["lump_one_width_three_total_clrs"] += Number(
                    lumpEl.no_of_clrs
                  );
                }
              }

              if (lumpEl.lump == 200) {
                if (widthEl.width == 36) {
                  element["lump_two_width_one_total_clrs"] += Number(
                    lumpEl.no_of_clrs
                  );
                }

                if (widthEl.width == 44) {
                  element["lump_two_width_two_total_clrs"] += Number(
                    lumpEl.no_of_clrs
                  );
                }

                if (widthEl.width == 58) {
                  element["lump_two_width_three_total_clrs"] += Number(
                    lumpEl.no_of_clrs
                  );
                }
              }
            });
          });
        }
      });
    });

    debugger;
  }

  checkSlidedata(type) {
    if (type == "NEXT") {
      if (this.currentSlide < this.styleList.length) {
        this.currentSlide += 1;
      }
    } else if (type == "BACK") {
      this.currentSlide -= 1;
    }
    this.style = this.styleList[this.currentSlide - 1].style;
    let styleQty = this.styleList[this.currentSlide - 1].style_qty;

    this.excelTitle = this.style + " - " + styleQty;

    if (this.currentSlide != 0) {
      this.getExcel(this.style);
    }

    console.log(this.varietyList);
    console.log(this.styleList[this.currentSlide - 1].style);
  }

  getExcel(current_style) {
    var obj = {};
    var excelArray = [];
    this.styleList.forEach((styleEl) => {
      this.varietyList.forEach((varEl) => {
        if (styleEl.style == current_style && varEl.style == current_style) {
          obj = {
            variety: varEl.variety,
            variety_qty: varEl.qty,
            variety_mtrs: varEl.width_total_mtrs,
            variety_designs: varEl.lump_appr_total_designs > 0 ?varEl.lump_appr_total_designs : 0,
            variety_clrs: varEl.lump_appr_tot_clrs > 0 ? varEl.lump_appr_tot_clrs : 0,
          };

          varEl.width.forEach((widthEl) => {
            widthEl.lumpData.forEach((lumpEl) => {
              if (lumpEl.lump == 100) {
                if (widthEl.width == 36) {
                  obj["lump_one_width_one_total_clrs"] = lumpEl.no_of_clrs;
                }

                if (widthEl.width == 44) {
                  obj["lump_one_width_two_total_clrs"] = lumpEl.no_of_clrs;
                }

                if (widthEl.width == 58) {
                  obj["lump_one_width_three_total_clrs"] = lumpEl.no_of_clrs;
                }
              }

              if (lumpEl.lump == 200) {
                if (widthEl.width == 36) {
                  obj["lump_two_width_one_total_clrs"] = lumpEl.no_of_clrs;
                }

                if (widthEl.width == 44) {
                  obj["lump_two_width_two_total_clrs"] = lumpEl.no_of_clrs;
                }

                if (widthEl.width == 58) {
                  obj["lump_two_width_three_total_clrs"] = lumpEl.no_of_clrs;
                }
              }
            });
          });
          excelArray.push(obj);
        }
      });
    });

    this.exceldata = this.getData(this.columns, excelArray);
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  exportToExcel() {
    this.excelService.exportAsExcelFile(this.exceldata, this.excelTitle);
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/purchasePlan/purchasePlanReport.ts